/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import mapboxgl from 'mapbox-gl';

import { NoMapboxGlNotice } from 'sarsaparilla';
import BasicMap from 'shared-ui/maps/templates/BasicMap';

import { convertSearchResultToGeoJson } from '../../utils/mapHelper';

import { type Facility } from './SitePassFacilities';

export default function FacilitiesMap({
    facilitiesList,
}: {
    facilitiesList: Facility[];
}) {
    const passGeoJsonData = convertSearchResultToGeoJson(facilitiesList);
    return (
        <div className="facilities-map" style={{ height: '100vh', maxHeight: '725px' }}>
            <div id="Mapbox" className="map">
                <BasicMap
                    center={[-98.585522, 39.8333333]}
                    mapContainer="Mapbox"
                    zoom={3.5}
                    service="pass"
                    skipMapFitBounds={true}
                    geojson={passGeoJsonData}
                />

                {!mapboxgl.supported() && <NoMapboxGlNotice />}
            </div>
        </div>
    );
}

// cspell:ignore Mapbox, MapboxGl, mapboxgl, mapbox
